import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "axios";
import { base_url } from "../../../utils/AxiosConfig";

let Leavepopupschema = Yup.object().shape({
  CmpCode: Yup.string(),
  EmpId: Yup.string(),
  LeaveCategory: Yup.string(),
  NoOfLeaves: Yup.string(),
});

const AddLeaveCatPopup = ({ EmpIdPopUp, setEmpIdPopup }) => {
  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  const companyCode = storedUserDataArray?.[0]?.cmpcode || null;

  const [LeaveCategory, setLeaveCategory] = useState(null);
  const [LeaveData, setLeaveData] = useState();

  useEffect(() => {
    if (!companyCode) return;
    const getLeave = async () => {
      try {
        const response = await axios.get(
          `${base_url}api/PersonalInfoLeaveCategoryList/${companyCode}/ALL/-`
        );
        if (response?.data) {
          setLeaveData(response.data);
        }
      } catch (error) {
        console.log("error fetching leave categories", error);
      }
    };
    getLeave();
  }, [companyCode]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      CmpCode: companyCode,
      EmpId: EmpIdPopUp || "",
      LeaveCategory: LeaveCategory,
      NoOfLeaves: "",
    },
    validationSchema: Leavepopupschema,
    onSubmit: (values) => {
      console.log(values);
    },
  });

  if (!EmpIdPopUp) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50" onClick={() => setEmpIdPopup(null)}>
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h1 className="text-lg font-semibold text-gray-600">Add Leave</h1>
          <button type="button" className="text-gray-400 hover:text-gray-600 text-xl leading-none" onClick={() => setEmpIdPopup(null)}>&times;</button>
        </div>
        <div className="px-6 py-4">
          <form onSubmit={formik.handleSubmit}>
            <div className="mb-3">
              <label className="block text-sm text-gray-500 mb-1">EmpId</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400 bg-gray-100"
                placeholder="Emp Id"
                name="EmpId"
                onChange={formik.handleChange("EmpId")}
                onBlur={formik.handleBlur("EmpId")}
                value={formik.values.EmpId}
                disabled
              />
            </div>
            <div className="mb-3">
              <label className="block text-sm text-gray-500 mb-1">Leave Category</label>
              <select
                onChange={formik.handleChange("LeaveCategory")}
                onBlur={formik.handleBlur("LeaveCategory")}
                value={formik.values.LeaveCategory}
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
              >
                <option value="">Leave Category</option>
                {LeaveData?.map((d, i) => (
                  <option key={i} value={d?.name} onClick={() => setLeaveCategory(d?.name)}>
                    {d?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="block text-sm text-gray-500 mb-1">No Of Leaves</label>
              <input
                type="text"
                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-blue-400"
                placeholder="Input Leave No Here.."
                name="NoOfLeaves"
                onChange={formik.handleChange("NoOfLeaves")}
                onBlur={formik.handleBlur("NoOfLeaves")}
                value={formik.values.NoOfLeaves}
              />
            </div>
            <div className="mt-4 text-end">
              <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md text-sm hover:bg-blue-600">Save</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddLeaveCatPopup;
